import {
  BasePackageIlluComponent,
  CommersialPackageIlluComponent,
  PremiumPackageIlluComponent,
  premiumPlusPackageIlluComponent,
} from 'assets/illustrations';
import { getPackMonthNumFromTextMode } from './mappers';

export const getDurationKey = (selectedDuration) => {
  switch (selectedDuration) {
    case 'monthly':
      return 'monthlyPrice';
    case 'quarterly':
      return 'quarterlyPrice';
    case 'yearly':
      return 'yearlyPrice';
    case 'triennial':
      return 'triennialPrice';
    default:
      return 'monthlyPrice';
  }
};

export const getIcon = (name) => {
  switch (name) {
    // case 'professional':
    //   return BasePackageIlluComponent;
    // case 'commerical':
    //   return CommersialPackageIlluComponent;
    case 'growth':
      return BasePackageIlluComponent;
    case 'premium':
      return CommersialPackageIlluComponent;
    case 'premiumPlus':
      return PremiumPackageIlluComponent;
    case 'vip':
      return premiumPlusPackageIlluComponent;
    default:
      break;
  }
};

const getPackageDiscount = (
  discountInfo,
  selectedPackageType,
  selectedDuration
) => {
  let discountPercent = 0;
  for (let key in discountInfo) {
    if (+key === +selectedPackageType) {
      const packageDuration = getPackMonthNumFromTextMode(selectedDuration);
      discountPercent = discountInfo[key][packageDuration];
    }
  }

  return discountPercent;
};

// Note: post price and tax are ' 0 ' in english locale
export const calculatePrices = ({
  price,
  isOfficialBillNeeded,
  useCredit,
  userCredit,
  discountInfo,
  selectedPackageType,
  selectedDuration,
  locale,
}) => {
  const postPrice = locale === 'fa' && isOfficialBillNeeded ? 75000 : 0;
  const creditAmount = useCredit ? userCredit : 0;

  let packageDiscount = getPackageDiscount(
    discountInfo,
    selectedPackageType,
    selectedDuration
  );
  const discountedPrice = packageDiscount
    ? price - (price * packageDiscount) / 100
    : price;
  const tax = locale === 'fa' ? (discountedPrice - creditAmount) * 0.1 : 0;
  const totalPrice = discountedPrice + tax + postPrice - creditAmount;
  const originaTotalPrice = price + tax + postPrice - creditAmount;
  const discountPercent = packageDiscount;
  // (100 * (originaTotalPrice - totalPrice)) / originaTotalPrice;
  return {
    totalPrice,
    postPrice,
    tax,
    discountPercent,
    originaTotalPrice,
  };
};
